<form class="industry-form" [formGroup]="industryForm">

  <mat-form-field appearance="fill">
    <mat-label>Name</mat-label>
    <input matInput required placeholder="Name" formControlName="name">
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Comments</mat-label>
    <textarea rows="5" matInput placeholder="Comments" formControlName="comments"></textarea>
  </mat-form-field>

</form>